<template>
  <section class="admin-page-container" v-if="logged">
    <div class="sidebar">
      <h4>Backoffice</h4>
      <h5>Admin Portal</h5>
      <ol class="sidebar-links">
        <li>
          <router-link to="/admin/interestPoints">Pontos de Interesse</router-link>
        </li>
        <li>
          <router-link to="/admin/calendar">Agenda</router-link>
        </li>
        <li>
          <router-link to="/admin/activities">Actividades</router-link>
        </li>
        <li>
          <router-link to="/admin/paths">Percusos</router-link>
        </li>
        <li>
          <router-link to="/admin/sliders">Sliders</router-link>
        </li>
        <li>
          <router-link style="opacity: 1; cursor: pointer" to="/">Voltar ao Site</router-link>
        </li>
        <li>
          <a style="opacity: 1; cursor: pointer" @click="logout()">Logout</a>
        </li>
      </ol>
    </div>
    <router-view></router-view>
  </section>
  <section v-else class="admin-page-login-container">
    <section class="top-admin-container">
      <div class="oh-elvas-logo-area">
        <div>
          <img src="../../assets/oh-elvas-icon-text.svg">
          <p>City of Elvas on your hands</p>
        </div>
      </div>
      <div class="top-right-container">
        <div>
          <h4>Login Admin Portal</h4>
          <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'general'">{{notificationLogin.text}}</p>
          <p>Email</p>
          <input v-model="email" name="email" placeholder="Inserir Email" :class="{'error': notificationLogin && (notificationLogin.element === 'email' || notificationLogin.element === 'general')}">
          <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'email'">{{notificationLogin.text}}</p>
          <p class="password-text">Password</p>
          <input type="password" v-model="password" name="password" placeholder="Inserir Password" :class="{'error': notificationLogin && (notificationLogin.element === 'password' || notificationLogin.element === 'general')}">
          <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'password'">{{notificationLogin.text}}</p>
        </div>
      </div>
    </section>
    <div class="bottom-admin-container">
      <div class="bottom-left-container">
        <h4>Elvas, Portugal</h4>
        <p>City Guide</p>
      </div>
      <div class="">
        <elvas-button :button="{title: 'Entrar'}" @click.native="login()"/>
      </div>
    </div>
  </section>
</template>
<script>
import ElvasButton from '../../components/elvas-button.vue'

export default {
  name: 'admin',
  components: {
    ElvasButton
  },
  data() {
    return {
      logged: false,
      email: null,
      password: null,
      notificationLogin: null
    }
  },
  mounted () {
    if (this.$store.state.user) this.logged = true
  },
  methods: {
    async login () {
      this.notificationLogin = null
      let errorMessage = 'Erro com o login'
      let element = 'general'
      if (!this.email || !this.password) {
        if (!this.password) {
          element = 'password'
          this.notificationLogin = { text: 'Password em falta', type: 'error', element }
        }
        if (!this.email) {
          element = 'email'
          this.notificationLogin = { text: 'Email em falta', type: 'error', element }
        }
        return
      }
      let response = await this.$store.dispatch('login', {email: this.email, password: this.password})
      if (response.data && response.data.success && response.data.user) {
        this.logged = true
        this.$router.push('/admin/interestPoints')
      } else {
        if (!response) return
        if (response.status === 422) {
          if (response.data.email) {
            errorMessage = 'Email invalido ou em falta'
            element = 'email'
          } else if (response.data.password) {
            errorMessage = 'Password invalida ou em falta'
            element = 'password'
          }
        }
        if (response.status === 401) {
          errorMessage = 'Email ou Password incorretos'
          element = 'general'
        }
        this.password = null
        this.notificationLogin = { text: errorMessage, type: 'error', element: element }
      }
    },
    async logout () {
      this.$store.dispatch('logout')
      this.$router.push('/admin')
      this.logged = false
    }
  }
}
</script>
<style lang="scss" scoped>
.admin-page-container {
  display: flex;
  min-height: 100vh;
  h4 {
    font-size: 26px;
    margin-top: 60px;
    margin-left: 20px;
    font-weight: bold;
    line-height: 0.92;
  }
  h5 {
    font-size: 26px;
    margin-left: 20px;
    line-height: 0.92;
  }
  .sidebar {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 220px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
    background: #f6b92f;
    color: white;
    .sidebar-links {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding: 20px 0;
      li {
        a {
          padding: 20px;
          display: block;
          color: white;
          font-weight: bold;
          opacity: 0.5;
          &.router-link-exact-active {
            background: #f6b92f;
            color: white;
            opacity: 1;
          }
        }
      }
    }
  }
}
.admin-page-login-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .top-admin-container {
    display: flex;
    flex-grow: 1;
    & > div {
      width: 50%;
    }
    .top-right-container {
      margin-bottom: 56px;
      div {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-left: 8vw;
        padding-right: 8vw;
      }
      h4 {
        margin-top: auto;
        margin-bottom: 76px;
        font-family: Sen;
        font-size: 48px;
        font-weight: bold;
        line-height: 1.13;
        letter-spacing: -0.86px;
        color: #a79374;

        @media (max-width: 750px){
          font-size: 32px;
          margin-top: 32px;
          margin-bottom: 16px;
        }
      }
      p:not(.error-text) {
        margin-top: 16px;
        font-family: Sen;
        font-size: 16px;
        font-weight: bold;
        color: #a79374;
        &.password-text {
          margin-top: 40px;
        }
      }
      .error-text {
        font-size: 12px;
        color: #ff4040;
        margin-top: 8px;
      }
    }

    @media(max-width: 750px){
      display: flex;
      flex-direction: column;
      overflow-y: hidden;
      & > div {
        width: 100%;
      }
      .oh-elvas-logo-area {
        height: 150px;
      }

   
    }
  }
  .oh-elvas-logo-area {
    display: flex;
    background: #f8edde;
    align-items: center;
    div {
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }
    img {
    }
    p {
      text-align: center;
      font-family: Sen;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.14;
      color: #a79374;
      margin-top: 30px;
    }

    @media (max-width: 750px){
      min-height: 200px;
      img {
        width: 200px;
        margin: 0 auto;
      }
    }
  }
  .bottom-admin-container {
    display: flex;
    min-height: 25vh;
    & > div {
      min-height: 150px;
      width: 50%;
    }
    .bottom-left-container {
      background: #f6b92f;
      color: white;
      h4 {
        margin-top: 56px;
        font-family: Sen;
        font-size: 24px;
        font-weight: bold;
        line-height: 0.83;
        text-align: center;
        color: #ffffff;
      }
      p {
        margin: 16px 0 0 0;
        opacity: 0.75;
        font-family: Sen;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.11;
        text-align: center;
      }
    }
    .elvas-button {
      margin-left: 8vw;
    }

    @media (max-width: 750px){
      flex-direction: column-reverse;
      & > div {
        min-height: 150px;
        width: 100%;

        & + div {
          min-height: 60px;
        }
      }
    }
  }
}
</style>
<style lang="postcss">
.admin-medium-bold-text {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.4px;
  color: #000000;
}
.admin-medium-bold-text-brown {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.4px;
  color: #a79374;
}
.admin-small-bold-text-brown {
  font-size: 16px;
  font-weight: bold;
  color: #a79374;
}
.admin-small-text-brown {
  color: #a79374;
  font-size: 16px;
}
.delete-button {
  margin-top: 40px;
}
</style>